/* eslint-disable @typescript-eslint/no-explicit-any */
import type { Client, RequestContext } from "../client";
import { BasicRepository } from "../repositories/basicRepository";
import type { MetadataTypeCollection } from "../resources/dynamicFormResources";
import { requestFeatureTrial } from "../resources/requestFeatureTrial";
import type { SettingsId } from "./SettingsId";
import type { SettingsMetadataItemResource } from "./settingsMetadataResource";
export class SettingsRepository extends BasicRepository<SettingsMetadataItemResource, SettingsMetadataItemResource> {
    constructor(client: Client, requestContext: RequestContext) {
        super("Configuration", client, requestContext);
    }
    getById(id: SettingsId): Promise<SettingsMetadataItemResource> {
        const url = this.client.getLink("Configuration");
        return this.client.get<SettingsMetadataItemResource>(this.requestContext, url, { id });
    }
    getValues(resource: SettingsMetadataItemResource): Promise<any> {
        return this.client.get<any>(this.requestContext, resource.Links["Values"]);
    }
    getMetadata(resource: SettingsMetadataItemResource): Promise<MetadataTypeCollection> {
        return this.client.get<MetadataTypeCollection>(this.requestContext, resource.Links["Metadata"]);
    }
    saveValues(metadataResource: SettingsMetadataItemResource, resource: any) {
        return this.client.put(this.requestContext, metadataResource.Links["Values"], resource);
    }
    async requestJiraServiceManagementIntegrationTrial() {
        return await requestFeatureTrial({ TypeOfFeature: "JiraServiceManagementIntegration" }, this.client, this.requestContext);
    }
    async requestServiceNowIntegrationTrial() {
        return await requestFeatureTrial({ TypeOfFeature: "ServiceNowIntegration" }, this.client, this.requestContext);
    }
}
